<div class="madar--v2 preview-map" [style.padding-bottom]="ratio ? (ratio * 100) + '%' : ''">
  <mat-card class="preview-map__card overflow-hidden" [ngClass]="['p-' + frame]">
    <google-map
      class="d-block w-100 h-100 pos-relative"
      *ngIf="mapLoaded"
      #googleMap
      [options]="{ disableDefaultUI: true }"
      [center]="mapCenter"
      [zoom]="zoom"
    >
      <ng-container *ngFor="let point of points; let i = index; let isFirst = first; let isLast = last">
        <app-map-overlay *ngIf="point?.lat && point?.lng" [latitude]="point.lat" [longitude]="point.lng" [title]="i ? 'End' : 'Start'">
          <ng-container
            *ngTemplateOutlet="customTemplates[MapElement.Marker] || markerDefaultTemplate; context: {index: i, isLast: isLast, isFirst: isFirst}"
          ></ng-container>
        </app-map-overlay>
      </ng-container>

      <map-polyline *ngIf="polylinePoints?.length" [options]="{strokeColor: '#1D63AE', strokeWeight: 6}" [path]="polylinePoints"></map-polyline>
      <map-polyline *ngIf="polylinePoints?.length" [options]="{strokeColor: '#29B2D9', strokeWeight: 3}" [path]="polylinePoints"></map-polyline>
    </google-map>

    <div class="preview-map__stats" *ngIf="duration">
      <p class="m-0">
        <time class="weight-semibold d-inline-block mx-1">
          <ng-container>
            <ng-container *ngIf="duration.days">{{duration.days}} {{'Shipments.Days' | translate}}</ng-container>
            <ng-container>{{duration.hours}} {{'Shipments.Hrs' | translate}}</ng-container>
            <ng-container>{{duration.mins}} {{'Shipments.Mins' | translate}}</ng-container>
          </ng-container>
        </time>
        <span class="text-500 weight-normal d-inline-block mx-1" *ngIf="distance">{{distance / 1000}} {{'Shipments.Km' | translate}}</span>
      </p>
    </div>
  </mat-card>
</div>

<ng-template #markerDefaultTemplate let-isLast="isLast" let-isFirst="isFirst" let-index="index">
  <app-marker
    color="primary"
    size="xs"
    style="transform: translate(-50%, -50%)"
    [matTooltip]="isLast ? 'DropOff' : isFirst ? 'PickUp' : ''"
    icon="marker"
  >
    <span class="mat-icon bg-white text-center d-flex align-center justify-center" style="font-family: inherit; border-radius: 50%">
      <small class="weight-semibold small d-inline-block align-middle" style="line-height: 1">{{index + 1}}</small>
    </span>
  </app-marker>
</ng-template>
